import './MissionContent.css'

const MissionContent = (props) => {
    return (
        <div
            className={props.className}
            onClick={props.onClick}>
            <img src={props.imageURL} alt={props.imageURL}/>
            <h4>{props.title}</h4>
            <p>{props.content}</p>
        </div>
    )
}

export default MissionContent;
